import { render, staticRenderFns } from "./questionOption.vue?vue&type=template&id=4060433f&scoped=true"
import script from "./questionOption.vue?vue&type=script&lang=js"
export * from "./questionOption.vue?vue&type=script&lang=js"
import style0 from "./questionOption.vue?vue&type=style&index=0&id=4060433f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4060433f",
  null
  
)

export default component.exports